import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={20}
    height={26}
    viewBox="0 0 20 26"
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#2D27F6'}
      d="M9.66 15.573c-2.58 0-4.68-2.1-4.68-4.68v-6.01c0-2.58 2.1-4.68 4.68-4.68 2.58 0 4.68 2.1 4.68 4.68v6.01c0 2.58-2.1 4.68-4.68 4.68Zm0-13.23c-1.4 0-2.54 1.14-2.54 2.54v6.01c0 1.4 1.14 2.54 2.54 2.54 1.4 0 2.54-1.14 2.54-2.54v-6.01c0-1.4-1.14-2.54-2.54-2.54Z"
    />
    <Path
      fill={props.fill || '#2D27F6'}
      d="M14.47 25.192H4.85a1.071 1.071 0 0 1 0-2.14h3.74v-2.74a9.425 9.425 0 0 1-5.64-2.72 9.424 9.424 0 0 1-2.78-6.71 1.071 1.071 0 0 1 2.14 0c0 1.96.76 3.81 2.15 5.2a7.29 7.29 0 0 0 5.2 2.15c1.97 0 3.81-.76 5.2-2.15a7.29 7.29 0 0 0 2.15-5.2 1.071 1.071 0 0 1 2.14 0c0 2.53-.99 4.92-2.78 6.71a9.425 9.425 0 0 1-5.64 2.72v2.74h3.74a1.071 1.071 0 0 1 0 2.14Z"
    />
  </Svg>
);
export default SvgComponent;
